/* tslint:disable */
/* eslint-disable */
/**
 * DexIt
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { AdvancedSearchRequestModel } from '../Models';
// @ts-ignore
import { EntitySearchRequestModel } from '../Models';
// @ts-ignore
import { EntitySearchResponseModel } from '../Models';
// @ts-ignore
import { RetrieveIn } from '../Models';
// @ts-ignore
import { SearchResponseModel } from '../Models';
/**
 * SearchApi - axios parameter creator
 * @export
 */
export const SearchApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AdvancedSearchRequestModel} advancedSearchRequestModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advancedSearch: async (advancedSearchRequestModel: AdvancedSearchRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'advancedSearchRequestModel' is not null or undefined
            assertParamExists('advancedSearch', 'advancedSearchRequestModel', advancedSearchRequestModel)
            const localVarPath = `/api/v1/search/advancedSearch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(advancedSearchRequestModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {EntitySearchRequestModel} entitySearchRequestModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entitySearch: async (entitySearchRequestModel: EntitySearchRequestModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entitySearchRequestModel' is not null or undefined
            assertParamExists('entitySearch', 'entitySearchRequestModel', entitySearchRequestModel)
            const localVarPath = `/api/v1/search/entitySearch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(entitySearchRequestModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RetrieveIn} retrieveIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (retrieveIn: RetrieveIn, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'retrieveIn' is not null or undefined
            assertParamExists('search', 'retrieveIn', retrieveIn)
            const localVarPath = `/api/v1/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(retrieveIn, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SearchApi - functional programming interface
 * @export
 */
export const SearchApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SearchApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AdvancedSearchRequestModel} advancedSearchRequestModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async advancedSearch(advancedSearchRequestModel: AdvancedSearchRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.advancedSearch(advancedSearchRequestModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchApi.advancedSearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {EntitySearchRequestModel} entitySearchRequestModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async entitySearch(entitySearchRequestModel: EntitySearchRequestModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EntitySearchResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.entitySearch(entitySearchRequestModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchApi.entitySearch']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {RetrieveIn} retrieveIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(retrieveIn: RetrieveIn, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(retrieveIn, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SearchApi.search']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SearchApi - factory interface
 * @export
 */
export const SearchApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SearchApiFp(configuration)
    return {
        /**
         * 
         * @param {AdvancedSearchRequestModel} advancedSearchRequestModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        advancedSearch(advancedSearchRequestModel: AdvancedSearchRequestModel, options?: any): AxiosPromise<SearchResponseModel> {
            return localVarFp.advancedSearch(advancedSearchRequestModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {EntitySearchRequestModel} entitySearchRequestModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        entitySearch(entitySearchRequestModel: EntitySearchRequestModel, options?: any): AxiosPromise<EntitySearchResponseModel> {
            return localVarFp.entitySearch(entitySearchRequestModel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RetrieveIn} retrieveIn 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(retrieveIn: RetrieveIn, options?: any): AxiosPromise<SearchResponseModel> {
            return localVarFp.search(retrieveIn, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SearchApi - interface
 * @export
 * @interface SearchApi
 */
export interface SearchApiInterface {
    /**
     * 
     * @param {AdvancedSearchRequestModel} advancedSearchRequestModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApiInterface
     */
    advancedSearch(advancedSearchRequestModel: AdvancedSearchRequestModel, options?: RawAxiosRequestConfig): AxiosPromise<SearchResponseModel>;

    /**
     * 
     * @param {EntitySearchRequestModel} entitySearchRequestModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApiInterface
     */
    entitySearch(entitySearchRequestModel: EntitySearchRequestModel, options?: RawAxiosRequestConfig): AxiosPromise<EntitySearchResponseModel>;

    /**
     * 
     * @param {RetrieveIn} retrieveIn 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApiInterface
     */
    search(retrieveIn: RetrieveIn, options?: RawAxiosRequestConfig): AxiosPromise<SearchResponseModel>;

}

/**
 * SearchApi - object-oriented interface
 * @export
 * @class SearchApi
 * @extends {BaseAPI}
 */
export class SearchApi extends BaseAPI implements SearchApiInterface {
    /**
     * 
     * @param {AdvancedSearchRequestModel} advancedSearchRequestModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    public advancedSearch(advancedSearchRequestModel: AdvancedSearchRequestModel, options?: RawAxiosRequestConfig) {
        return SearchApiFp(this.configuration).advancedSearch(advancedSearchRequestModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {EntitySearchRequestModel} entitySearchRequestModel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    public entitySearch(entitySearchRequestModel: EntitySearchRequestModel, options?: RawAxiosRequestConfig) {
        return SearchApiFp(this.configuration).entitySearch(entitySearchRequestModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RetrieveIn} retrieveIn 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SearchApi
     */
    public search(retrieveIn: RetrieveIn, options?: RawAxiosRequestConfig) {
        return SearchApiFp(this.configuration).search(retrieveIn, options).then((request) => request(this.axios, this.basePath));
    }
}

